export default __webpack_public_path__ + "static/media/Slide_4.598eb841.jpeg";